/**
 * bundle Logs
 */

// React
import React, {useEffect} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../redux/reducers';
import {getLogsAction, getBundleWithIdAction} from '../bundles/actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {makeSelectLogs, makeSelectBundle} from '../bundles/selectors';

//UI
import theme from '../../theme';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {Typography, Paper, Button, Grid, Divider} from '@material-ui/core';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';

// Icon
import Icon from '@mdi/react';
import {
  mdiDolly,
  mdiClose,
  mdiCarArrowLeft,
  mdiArrowRight,
  mdiDotsHorizontalCircleOutline,
  mdiPackageVariantClosed,
  mdiTruckFastOutline,
  mdiMapMarkerCheckOutline,
  mdiClipboardCheckOutline,
  mdiAccountOutline,
  mdiCardAccountPhoneOutline,
  mdiCalendarRange,
  mdiPackageVariant,
  mdiMapMarkerRadiusOutline,
} from '@mdi/js';

// Helper
import {
  translateBundleStatus,
  formaterPhoneNumber,
  translateUserRoles,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import {Log} from '../bundles/interfaces';
import {SelectorProps, Props} from './interfaces';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    secondaryTail: {
      backgroundColor: theme.palette.secondary.main,
    },
    paperHistory: {
      '@media (min-width: 768px)': {
        width: '40%',
      },
    },
    headerBox: {
      display: 'flex',

      alignItems: 'center',
      marginBottom: '28px',
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    contentBox: {
      padding: theme.spacing(2),
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paper: {
      marginTop: theme.spacing(4),
      marginBottom: '36px',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
    divider: {
      width: '97%',
      margin: '0 auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
  })
);

//const
const iconStatus = {
  ASSIGNED: mdiCarArrowLeft, //'اختصاص داده شده',
  CREATED: mdiPackageVariantClosed, //' مرسوله ایجاد شده',
  CANCELLED: mdiClose, //'لغو شده',
  LOADED: mdiDolly, //'بارگیری شده',
  PROCESS_FAILED: mdiDotsHorizontalCircleOutline, //'ناموفق',
  PROCESS_STARTED: mdiTruckFastOutline, //'راننده در مسیر مرکز',
  PROCESSED: mdiClipboardCheckOutline, //'راننده تحویل داد',
  VEHICLE_ARRIVED: mdiMapMarkerCheckOutline, // 'ماشین به مرکز رسیده',
};
const colorStatus = {
  ASSIGNED: theme.palette.green.main, //'اختصاص داده شده',
  CREATED: theme.palette.green.main, //' مرسوله ایجاد شده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  LOADED: theme.palette.green.main, //'بارگیری شده',
  PROCESS_FAILED: theme.palette.orange.main, //'ناموفق',
  PROCESS_STARTED: theme.palette.green.main, //'راننده در مسیر مرکز',
  PROCESSED: theme.palette.green.main, //'راننده تحویل داد',
  VEHICLE_ARRIVED: theme.palette.green.main, // 'ماشین به مرکز رسیده',
};

export function Logs(props: Props) {
  const classes = useStyles();

  useEffect(() => {
    const {id} = props.match.params;
    props.getLogsDispatch(id);
    props.bundleWithIdActionDispatch(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <div className={classes.headerBox}>
        <Typography
          variant="h6"
          component="div"
          style={{marginLeft: '20px', fontSize: '18px'}}
        >
          {`تاریخچه مرسوله`}
        </Typography>
        <span className={classes.contentlabelTitle}>
          {props.match.params?.id}
        </span>
      </div>
      <Button
        aria-label="details"
        size="medium"
        onClick={() => window.history.back()}
      >
        <Icon path={mdiArrowRight} size={1} className={classes.icon} />
        {`بازگشت`}
      </Button>

      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {`نام راننده:  `}
              </span>

              <span>{props.bundle.driverName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCardAccountPhoneOutline}
                  size={1}
                  className={classes.icon}
                />
                {`شماره تماس راننده:  `}
              </span>
              <span>{formaterPhoneNumber(props.bundle.driverPhoneNumber)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarRange}
                  size={1}
                  className={classes.icon}
                />
                {`زمان تحویل:  `}
              </span>
              <span>
                {props.bundle.deliveryDate &&
                  jMoment(props.bundle.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPackageVariant}
                  size={1}
                  className={classes.icon}
                />
                {`شناسه مرسوله:  `}
              </span>
              <span>{props.bundle.id}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerRadiusOutline}
                  size={1}
                  className={classes.icon}
                />
                {` نام مرکز:  `}
              </span>
              <span>{props.bundle.centerName}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>

      <Grid container>
        <Grid item xs={12}>
          <Timeline align="left">
            {props.logs
              ?.slice()
              .reverse()
              ?.map((log: Log, index: number) => (
                <TimelineItem
                  className={classes.missingOppositeContent}
                  key={index}
                >
                  <TimelineSeparator>
                    <TimelineDot
                      style={{
                        backgroundColor: colorStatus[log.newStatus],
                        borderColor:
                          index === 0 ? theme.palette.secondary.main : '',
                      }}
                    >
                      <Icon path={iconStatus[log.newStatus]} size={1} />
                    </TimelineDot>
                    {index !== props.logs?.length - 1 ? (
                      <TimelineConnector />
                    ) : (
                      ''
                    )}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3} className={classes.paperHistory}>
                      <Typography component="div" className={classes.titleBox}>
                        {log.time &&
                          jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                      <div className={classes.contentBox}>
                        <div>
                          <span className={classes.contentlabel}>
                            وضعیت سفارش:
                          </span>
                          <span>{translateBundleStatus(log.newStatus)}</span>
                        </div>
                        <div style={{marginTop: '12px'}}>
                          <span className={classes.contentlabel}>کاربر:</span>
                          <span>{log.modifierName}</span>
                          <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                          <span>{translateUserRoles(log.modifierRole)}</span>
                        </div>

                        {log.description && (
                          <div style={{marginTop: '12px'}}>
                            <span className={classes.contentlabel}>
                              توضیحات:
                            </span>
                            <span>{log.description}</span>
                          </div>
                        )}
                      </div>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ))}
          </Timeline>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  bundle: makeSelectBundle(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({id})),
    bundleWithIdActionDispatch: (id: number) =>
      dispatch(getBundleWithIdAction({id})),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Logs);
